import script from "./NavigationView.vue?vue&type=script&setup=true&lang=js"
export * from "./NavigationView.vue?vue&type=script&setup=true&lang=js"

import "./NavigationView.vue?vue&type=style&index=0&id=9991c60a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9991c60a"]])

export default __exports__